module.exports = __webpack_public_path__ + "img/sierraint4.71a56a04.png";